import { TranslationType } from '../types';

export const premiumDiscountMapping = (t: TranslationType) => {
  const mapping = {
    yes: t('Yes'),
    no: t('No')
  };
  return mapping;
};
